exports.APIS = {
  Auth: {
    signup: "/website/user/sing-up",
    login: "/website/user/login",
    OAuthlogin: "/website/user/login",
    SEND_OTP: "/common/verify-otp/send-otp",
    VERIFY_OTP: "/common/verify-otp/verify-otp",
    SET_PASSWORD: "/common/verify-otp/change-password",
    SEND_OTP_FOR_RESET: "/website/auth/email-contact-otp-send",
    VERIFY_OTP_FOR_RESET: "/website/auth/email-contact-verify-otp",
  }, // mine

  GET_NOTIFICATIONS: "/website/notification",
  NOTIFICATION_STATUS: "/website/notification",
  USER: {
    MY_ACCOUNT: "/website/user/get-user",
    MY_ACCOUNT_UPDATE: "/website/user/update-profile",
    UPDATE_CONTACT_NO: "",
    MY_PHOTO_UPDATE: "",
    MY_EVENT_REGISTRATION: "/website/registration",
    SANKALP_NOTE: "/website/common/shankalp-note",
    MY_ROOM_BOOKINGS: "/common/stay-booking",
  },
  UserGet: "/common/auth/user-info",
  ChangePassword: "/common/auth/change-password",

  Masters: {
    Country: "/admin/masters/country",
    Rooms: "/website/common/all-rooms",
  },

  RB: {
    CheckAvailibility: "/common/stay-booking/availability",
    BookRoom: "/common/stay-booking",
  },

  ContactUs: {
    Contact_Us: "/website/common/contact-us",
  },
  Order: {
    ORDER_ADDRESS: `/website/user-address`,
    ORDER: "/website/product-order",
    ORDER_CALCULATION: "/website/product-order/calculate",
    REORDER: "",
    COUPON_APPLYED: `/website/coupons/valid`,
    ORDER_RETURN: "/website/product-order/order-return",
    ORDER_CANCEL: "/website/product-order/order-cancel",
    SINGLE_RETURN: "/website/product-order/return",
    SINGLE_CANCEL: "/website/product-order/cancel",
    ALL_CANCEL: "/website/product-order/cancel-order",
    ALL_RETURN: "/website/product-order/return/order",
  },

  RaiseFund: {
    Raise: "/website/fund-raise/fundraise",
    Raise2: "/website/fund-raise/fundraise2",
  },

  VolunteerDetail: {
    Volunteer: "/website/volunteer-stepform",
    GetVolunteer: "/website/volunteer-stepform",
  },

  Commons: {
    Share_Your_Experience: "/website/common/share-experience",
    AllStoreBanners: "/website/home/store-banner",
    AllFrame: "/website/common/all-frames",
    AllFrameCategory: "/website/common/all-frame-category",
    ReturnReason: "/common/masters/all-return-reasons",
    CancelReason: "/common/masters/all-cancel-reasons",
    RoomCancelReason: "/website/common/all-room-cancel-reasons",
    SpandanFormStatus: "/website/common/spandan-form-status",
    EventFormStatus: "/website/common/event-form-status",
    At_Om_Tapovan: "/website/common/at-om-tapovan",
    OurMission: "/website/common/our-mission",
    OurVission: "/website/common/our-vission",
    AllLanguage: "/common/masters/all-language",
    BlogCategory: `/website/common/all-blogcategory`,
    GurudevContent: `/website/common/gurudev-content`,
    ComingFestival: `/website/common/next-festival`,
    welcomeText: `/website/common/welcome-text`,
    COUPON: `/website/coupons`,
    RoomType: "/website/common/all-room-types",
    InsightExclusive: "/website/common/insight-exclusive",
    Centers: "/website/common/centers",
    OurOfferings: "/website/common/our-offerings",
    Event: "/website/common/events",
    EventCategory: "/website/common/events-types",
    EventRegistration: "/website/registration/event",
    EventAttendance: "/website/registration/event-attendance",
    EventPrograms: "/website/common/event-programs",
    InsightVideo: "/website/common/insight-video",
    InsightsArticle: "/website/common/insight-article",
    SpiritualInsight: "/website/common/spiritual-insight",
    SingleSpiritualInsight: "/website/common/get-spiritual-insight",
    AllBlog: "/website/common/blogs",
    AllPravachan: "/website/common/pravachan",
    AllTestimonials: "/website/common/testimonials",
    OurCoreVision: "/website/common/our-core-vision",
    AllBanner: "/website/common/banner",
    GuruShorts: "/website/common/guru-shorts",
    AllChants: "/website/common/chants",
    AllChantsAlbum: "/website/common/all-chants-album",
    GurujiWisdom: "/website/common/guruji-wisdom",
    QuoteOfTheDay: "/website/common/quote-of-the-day",
    AllMeditaion: "/website/common/meditation",
    AllVolunteer: "/website/common/volunteering",

    AllCountry: "/common/masters/all-country",
    AllGenders: "/common/masters/all-genders",
    AllState: "/common/masters/all-state",
    AllCity: "/common/masters/all-city",
    AllPincode: "/common/masters/all-pincode",
    AllArea: "/common/masters/all-area",
    AllHelpCategory: "/common/masters/all-help-category",
    AllGalleryCategory: "/common/masters/all-gallery-category",
    AllCategory: "/common/masters/all-p-category",
    AllTestimonial: "/common/masters/all-testimonials",
    AllOurTeam: "/common/masters/all-our-team",
    AllArticleNews: "/common/masters/all-article",
    AllGallery: "/common/masters/all-gallery",
    AllInnerGalary: "/common/masters/gallery",
    AllVolunteerPositon: "/common/masters/volunteer-position",
    AllDaysOfService: "/common/masters/days-of-service",
    AllHoursOfService: "/common/masters/hour-of-service",

    AllTrustSafety: "/common/masters/all-trust-safety",
    AllHelpQuestion: "/common/masters/all-help-center",
    AllStates: "/common/masters/all-state",
    AllVolunteerMode: "/common/masters/all-volunteer-mode",
    GetFundRaisesByCategory: "/website/fund-raise",
    GetFundRaisesById: "/website/fund-raise/get-fundraise",
  },

  Spandan: {
    GetSpandan: "/website/spandan/spandan",
    AllGetSpandan_Banner: "/website/spandan/spandan-banner",
    AllSpandan_Videos: "/website/spandan/spandan-video",
    AllSpandan_Session_Type: "/website/spandan/spandan-session",
    SpandanRegistration: "/website/registration/spandan",
  },
  Footers: {
    GetConcentTerms: "/website/common/concent-and-term", //
    AllTermsCondition: "/website/common/terms-and-condition", //
    AllPrivacyPolicy: "/website/common/privacy-policy",
    AllShippingAndDeliveryPolicy:
      "/website/common/shipping-and-delivery-policy",
    AllDonationCancellation:
      "/website/common/donation-cancellation-and-refund-policy",
    AllAboutUs: "/website/common/about-us",
    AllFaq: "/website/common/faq",
    AllAppsetup: "/website/common/app-setup",
    AllSocialLink: "/website/common/social-link",
  },

  UserManagement: {
    Roles: "/admin/employee-management/role",
    Builder: "/admin/employee-management/builder",
    Users: "/admin/employee-management/user",
    Sales: "/admin/employee-management/sales",
  },

  Commerce: {
    Products: "/website/product/all-products",
    Product: "/website/product",
  },

  WishList: {
    WISHLIST: "/website/wishlist",
    CHECk_ITEM_IN_WISHLIST: "/website/wishlist/check",
  },

  reviewRating: {
    REVIEWRATING: "/website/rating-review",
    AVG_REVIEW_RATING: "/website/rating-review/avg",
  },

  CART: {
    CART: `/website/cart`,
    GET_ALL_CART_WITHOUT_LOGIN: `/website/cart/without-login`,
    CHECk_ITEM_IN_CART: `/website/cart/check`,
    CART_QUANTITY: `/website/cart/quantity`,
  },

  Donation: {
    Donations: "/website/donation/all-donation",
    UserDonationDetail: "/website/user-donation-details",
  },

  Volunteer_Stepform: {
    StepOne: "/website/volunteer-stepform/stepone",
    StepTwo: "/website/volunteer-stepform/steptwo",
    GetALL: "/website/volunteer-stepform",
  },
  WALLET: {

    WALLET: "/website/wallet"

  }
};
